<template>
  <form-edit-activity
      :form-type="FORM_TYPE"
      ref="formEditor"
      :mode="mode"
      :entity-id="entityId"
      @form-created="formCreated"
      @form-loaded="initialDataLoad"
      :context="context"
      :custom-add="true"
      @saved="saveRolesAndDataAccessInDelegation"
  >
    <template v-slot:mixins v-if="form">
      <form-mixin
          after="delegateAllDataAccess"
          :row="true"
          @change-read-only="setReadOnly"
      >
        <div>
          <MultiselectList
              v-model="delegatedRoles"
              :all-items="yourRoles"
              :read-only="readOnly"
              @delete-item="deleteItemFromSelectedItems"
              @add-item="addItemToSelectedItems"
              left-label="Deputies roles"
              right-label="Your roles"
              label-field="name"
              class="p-4"
          ></MultiselectList>
          <MultiselectList
              v-model="delegatedDataAccess"
              :all-items="yourDataAccess"
              :read-only="readOnly"
              @delete-item="deleteItemFromSelectedItemsDataAccess"
              @add-item="addItemToSelectedItemsDataAccess"
              left-label="Deputies data access"
              right-label="Your data access"
              label-field="formTitle"
              class="pb-5"
          ></MultiselectList>
        </div>
      </form-mixin>
    </template>
  </form-edit-activity>
</template>

<script>

import PermissionsSet from "@/server/PermissionsSet";
import Activity from "@/activity/Activity";
import Rpc from "@/Rpc";
import FormsLoader from "@/components/forms/FormsLoader";
import FormMixin from "@/components/forms/customizations/mixins/FormMixin";
import FormEditActivity from "@/activity/templates/layouts/forms/FormEditActivity";
import Delegation from "@/server/com/silkplm/model/plm/Delegation";
import MultiselectList from "@/components/list/MultiselectList";
import _ from "lodash";

const FORM_TYPE = Delegation;

export default {
  name: "Delegations",
  components: {FormMixin, FormEditActivity, MultiselectList},

  async mounted() {
    if (this.mode === "NEW") {
      this.readOnly = false;
    }
    // to było powodem podwójnego zakładania się delegacji
    // this.$onInsert(Delegation, async (changeEvent) => {
    //   await this.saveRolesAndDataAccessInDelegation(changeEvent.id)
    // });

    // nie mozna tutaj ladowac danych na bazie entity ktore edytujemy, bo ono jeszcze tutaj nie jest zaladowane
    // trzeba to robic w evencie @form-loaded (initialDataLoad)
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      if (this.mode === "NEW") {
        return $tr('delegationEditor.new','New ') + this.formConfig.entityName;
      } else {
        return $tr('delegationEditor.edit','Edit ') + (this.formConfig.entityName ?? "");
      }
    },

    async canClose() {
      return this.$refs.formEditor.canClose();
    },


    setReadOnly(val) {
      this.readOnly = val;
    },

    async initialDataLoad() {
      if(this.loaded){
        return;
      }
      this.loaded = true;
      this.userId = this.form.fields.userId.value;
      this.entityId = this.form.fields.id.value;
      await this.loadData();
    },

    async saveRolesAndDataAccessInDelegation(entity) {
      let entityId = entity.id;
      let yourDataAccess = [];
      let delegatedDataAccess = [];
      for (let el of this.yourDataAccess) {
        yourDataAccess.push(el.formId);
      }
      for (let el of this.delegatedDataAccess) {
        delegatedDataAccess.push(el.formId);
      }

      let delegatedRolesIds = [];
      let yourRolesIds = [];
      if (this.delegatedRoles) {
        this.delegatedRoles.forEach(role => {
          delegatedRolesIds.push(role.id);
        });
      }
      if (this.yourRoles) {
        this.yourRoles.forEach(role => {
          yourRolesIds.push(role.id);
        });
      }

      if (entityId) {
        await Rpc.plm.services.DelegationService.delegationRolesAndDataAccessToUser(
            entityId, delegatedRolesIds, yourRolesIds, delegatedDataAccess, yourDataAccess).lock();
      } else {
        let entityId = null;
        if (this.form.fields.id.value) {
          entityId = this.form.fields.id.value;
        } else {
          entityId = this.form.originalSource.id;
        }
        if (entityId) {
          await Rpc.plm.services.DelegationService.delegationRolesAndDataAccessToUser(
              entityId, delegatedRolesIds, yourRolesIds, delegatedDataAccess, yourDataAccess).lock();
        } else {
          console.error("No ID generated");
        }
      }
    },

    deleteItemFromSelectedItems(index) {
      if (index !== -1) {
        this.yourRoles.push(this.delegatedRoles[index]);
        this.delegatedRoles.splice(index, 1);
      }
    },

    addItemToSelectedItems(index) {
      if (index !== -1) {
        this.delegatedRoles.push(this.yourRoles[index]);
        this.yourRoles.splice(index, 1);
      }
    },

    deleteItemFromSelectedItemsDataAccess(index) {
      if (index !== -1) {
        this.yourDataAccess.push(this.delegatedDataAccess[index]);
        this.delegatedDataAccess.splice(index, 1);
      }
    },

    addItemToSelectedItemsDataAccess(index) {
      if (index !== -1) {
        this.delegatedDataAccess.push(this.yourDataAccess[index]);
        this.yourDataAccess.splice(index, 1);
      }
    },

    /** @type {FormModel} form */
    async formCreated(form) {
      this.form = form;
    },

    async loadData() {
      // this.delegatedRoles = [];
      // this.delegatedDataAccess = [];
      let allYourAssignedRoles = await Rpc.Roles.listRolesForApplicationUser(SessionManager.applicationUser.id).lock();
      if (this.mode === "EDIT") {
        let userId = this.form.fields.userId.value;
        let id = this.form.fields.id.value;
        if (userId && id) {
          this.delegatedRoles = await Rpc.plm.services.DelegationService.listDelegationUserRoleBindingForUserInDelegation(id).lock();
          let delegatedFormsIds = await Rpc.plm.services.DelegationService.listDelegationUserDataAccessForUserInDelegation(id).lock();
          let allForms = await Rpc.Forms.getForms().lock();
          let tempList = []
          for (let formId of delegatedFormsIds) {
            let el = {};
            let form = _.find(allForms, {'formId': formId});
            el["formId"] = formId;
            el["formTitle"] = form.formTitle;
            tempList.push(el);
          }
          this.delegatedDataAccess = tempList;
        }
      }
      this.yourRoles = [];
      this.yourDataAccess = [];
      if(allYourAssignedRoles != null){
        for (let role of allYourAssignedRoles) {
          if(this.delegatedRoles?.length){
            let delegatedRole = _.find(this.delegatedRoles, {'name': role.name});
            if (!delegatedRole) {
              this.yourRoles.push(role);
            }
          }
          else{
            this.yourRoles.push(role);
          }
        }
      }
      await this.loadAdvancedPermissions();
    },

    async loadAdvancedPermissions() {
      let allYourAssignedDataAccess = await Rpc.Users.listAssignedAdvancedPermissions(SessionManager.applicationUser.id).lock();
      let formsIds = [];
      for (let formId of allYourAssignedDataAccess) {
        let found = false;
        for (let delegatedData of this.delegatedDataAccess) {
          if (delegatedData.formId === formId) {
            found = true;
          }
        }
        if (!found) {
          formsIds.push(formId);
        }
      }
      let allForms = await Rpc.Forms.getForms().lock();
      let tempList = [];
      for (let formId of formsIds) {
        let el = {};
        let form =  _.find(allForms, {'formId': formId});
        el["formId"] = formId;
        el["formTitle"] = form.formTitle;
        tempList.push(el);
      }
      this.yourDataAccess = tempList;
    },

  },

  props: {
    entityId: {default: null},
    mode: {type: String, default: "NEW"},
    context: {default: null},
  },

  watch: {
    'form.fields.userId.value': async function (val) {
      this.userId = val;
    },
    'form.fields.id.value': async function (val) {
      this.entityId = val;
    },
    'form.fields.delegateAllRoles.value': async function (newVal, oldVal) {
      if (newVal === false && oldVal === true) {
        this.yourRoles = _.concat(this.delegatedRoles, this.yourRoles);
        this.delegatedRoles = [];
      } else if (newVal === true && oldVal === false || (oldVal === null || oldVal === undefined) && newVal === true) {
        this.delegatedRoles = _.concat(this.delegatedRoles, this.yourRoles);
        this.yourRoles = [];
      }
    },
    'form.fields.delegateAllDataAccess.value': async function (newVal, oldVal) {
      if (newVal === false && oldVal === true) {
        this.yourDataAccess = _.concat(this.delegatedDataAccess, this.yourDataAccess);
        this.delegatedDataAccess = [];
      } else if (newVal === true && oldVal === false || (oldVal === null || oldVal === undefined) && newVal === true) {
        this.delegatedDataAccess = _.concat(this.delegatedDataAccess, this.yourDataAccess);
        this.yourDataAccess = [];
      }
    },
  },

  data: function () {
    return {
      FORM_TYPE,
      /** @type {FormModel} */
      form: null,
      readOnly: true,
      permissions: new PermissionsSet(),
      formConfig: FormsLoader.detectFormConfig(FORM_TYPE),
      formId: FormsLoader.detectFormConfig(FORM_TYPE).formId,
      delegatedRoles: [],
      delegatedDataAccess: [],
      yourRoles: [],
      yourDataAccess: [],
      userId: null,
    }
  }
}
</script>

<style scoped>

</style>